import React, { useEffect, useState } from 'react';
import Sidebar from "./Sidebar";
import Header from './Header'
import Footer from './Footer'
import { useAppContext } from '../context/AppContext';
import GlobalLoader from "../components/GlobalLoader";
import { Navigate } from 'react-router-dom';
import moment from 'moment';
import { getCheckUserTrialInfo } from '../helper/backend-methods';
function ProtectedLayout(props) {
    // console.log("props", props)

    const { isTrial, daysRemaining, trialEndDate, updateTrialInfo, setIsActiveSubscription } = useAppContext();
    const [sidebarExpand, setSidebarExpand] = useState(true)
    const [showSidebar, setShowSidebar] = useState(true)
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        if (isTrial === null) {
            getCheckUserTrialInfo().then(({data}) => {
                if (data.success) {
                    updateTrialInfo({ isTrial: data.data.isTrialUser, daysRemaining: data.data.daysRemaining ? data.data.daysRemaining : 0, trialEndDate: data.data.trialEndsAt ? data.data.trialEndsAt : null });
                    setIsActiveSubscription(data.data.isActiveSubscription)
                    setLoading(false)
                }
            }).catch((e) => {
                console.log(e)
                setLoading(false)
            })
        }
        if (isTrial && moment().isAfter(moment(trialEndDate))) {
            updateTrialInfo({ isTrial: true, daysRemaining: 0, trialEndDate: trialEndDate })
            setLoading(false)
        }
        else {
            setLoading(false)
        }
        // after API call
    }, [])

    const expandSidebar = () => {
        const hasAttribute = document.body.hasAttribute('data-sidebar');
        if (hasAttribute) {
            const attributeValue = document.body.getAttribute('data-sidebar');
            if (attributeValue === "default") {
                document.body.setAttribute("data-sidebar", "hidden");
                setSidebarExpand(false);
            }
            else {
                document.body.setAttribute("data-sidebar", "default");
                setSidebarExpand(true);
            }
        }
        else {
            document.body.setAttribute("data-sidebar", "hidden");
            setSidebarExpand(false);
        }
    }

    useEffect(() => {
        setShowSidebar(props.showSideBar)
        const handleResize = () => {
            if (window.innerWidth < 992) {
                document.body.setAttribute("data-sidebar", "hidden");
                setSidebarExpand(false);
            } else {
                document.body.setAttribute("data-sidebar", "default");
                setSidebarExpand(true);
            }
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <>
            {
                loading ?
                    <GlobalLoader isLoading={loading} /> :
                    !props.allowedInTrail && isTrial && (daysRemaining < 1) ?
                        <Navigate to="/pricing-plans" /> :
                        <>
                            < div id="layout-wrapper">
                                {
                                    showSidebar ?
                                        <>
                                            <Header expandSidebar={expandSidebar} />
                                            <Sidebar sidebarExpand={sidebarExpand} />
                                        </> : null
                                }
                                <div className='main-content'>
                                    {props.children}
                                    {
                                        showSidebar ?
                                            <>
                                                <Footer />
                                            </> : null
                                    }

                                </div>
                            </div>
                        </>
            }
        </>
    )
}

export default ProtectedLayout; 